import axios from "../http";

class Intercept {
  /* 拦截入库列表 */
  static getInterceptWarehouseList(pageNo, customerId, code, beginDate, endDate, status) {
    const url = `/zwy/api/intercept/order/warehouse/list?pageNo=${pageNo}&customerId=${customerId}&code=${code}&beginDate=${beginDate}&endDate=${endDate}&status=${status}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 拦截 */
  static postIntercept(data) {
    const url = "/zwy/api/intercept/order/warehouse/intercept";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 入库 */
  static postInstock(data) {
    const url = "/zwy/api/intercept/order/warehouse/instock";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Intercept;